import { render, staticRenderFns } from "./EGBHeatmaps.vue?vue&type=template&id=0090b5d4&"
import script from "./EGBHeatmaps.vue?vue&type=script&lang=js&"
export * from "./EGBHeatmaps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports